import { render, staticRenderFns } from "./videoPlayCom.vue?vue&type=template&id=78a87fa7&scoped=true"
import script from "./videoPlayCom.vue?vue&type=script&lang=js"
export * from "./videoPlayCom.vue?vue&type=script&lang=js"
import style0 from "./videoPlayCom.vue?vue&type=style&index=0&id=78a87fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a87fa7",
  null
  
)

export default component.exports